import GoogleDocsPlaybackWrapper from "./GoogleDocsPlaybackWrapper";
export default GoogleDocsPlaybackWrapper;
